import request from '@/utils/request'

export default {
	getList (params) {
		return request.post('/goods/goods/getList', params)
	},
	getDetail (params) {
		return request.post('/goods/goods/getDetail', params)
	},
	getCount (params) {
		return request.post('/goods/goods/getCount', params)
	},
	postAdd (params) {
		return request.post('/goods/goods/postAdd', params) 
	},
	postExport () {
		return request.post('/goods/goods/postExport')
	},
    // 批量添加
	postBatchAdd (params) {
		return request.post('/goods/goods/postBatchAdd', params) 
	},
	postModify (params) {
		return request.post('/goods/goods/postModify', params) 
	},
	postBatchModify (params) {
		return request.post('/goods/goods/postBatchModify', params) 
	},
	postDelete (params) {
		return request.post('/goods/goods/postDelete', params) 
	},
	modTaste (params) {
		return request.post('/goods/goods/modTaste', params) 
	},
	delTaste (params) {
		return request.post('/goods/goods/delTaste', params) 
	},
	getBarcode () {
		return request.post('/goods/goods/getBarcode')
	},
	checkBarcode (params) {
		return request.post('/goods/goods/checkBarcode', params) 
	},
	getCategoryList () {
		return new Promise((resolve, reject) => {
			request.post('/goods/category/getList').then(response => {
				response.data.data.forEach((item, index) => {
					let str = '&nbsp;&nbsp;&nbsp;&nbsp;'
					item.format_cat_name =  item.cat_name.padStart(item.cat_name.length + str.length * (item.depth - 1), str)
				})
				resolve(response)
			}).catch(error => {
          		reject(error)
        	})
		})
	},
	postCategoryAdd (params) {
		return request.post('/goods/category/postAdd', params)
	},
	postCategoryModify (params) {
		return request.post('/goods/category/postModify', params)
	},
	postCategoryDelete (params) {
		return request.post('/goods/category/postDelete', params)
	},
	getBrandList (params) {
		return request.post('/goods/brand/getList', params) 
	},
	getBrandCount (params) {
		return request.post('/goods/brand/getCount', params) 
	},
	getBrandDetail (params) {
		return request.post('/goods/brand/getDetail', params) 
	},
	postBrandAdd (params) {
		return request.post('/goods/brand/postAdd', params)
	},
	postBrandModify (params) {
		return request.post('/goods/brand/postModify', params)
	},
	postBrandDelete (params) {
		return request.post('/goods/brand/postDelete', params)
	},
	getSupplierList () {
		return request.post('/goods/supplier/getList') 
	},
	getTastesList () {
		return request.post('/goods/goods/getTastesList') 
	},
	getTasteDetail (params) {
		return request.post('/goods/goods/tasteDetail',params) 
	},
	getSupplierDetail (params) {
		return request.post('/goods/supplier/getDetail', params) 
	},
	postSupplierAdd (params) {
		return request.post('/goods/supplier/postAdd', params)
	},
	postSupplierModify (params) {
		return request.post('/goods/supplier/postModify', params)
	},
	postSupplierDelete (params) {
		return request.post('/goods/supplier/postDelete', params)
	},
    // 单位
	getUnitList () {
		return request.post('/goods/unit/getList') 
	},
	getUnitDetail (params) {
		return request.post('/goods/unit/getDetail', params) 
	},
	postUnitAdd (params) {
		return request.post('/goods/unit/postAdd', params)
	},
	postUnitModify (params) {
		return request.post('/goods/unit/postModify', params)
	},
	postUnitDelete (params) {
		return request.post('/goods/unit/postDelete', params)
	},
    // 标签
	getRemarkList (params) {
		return request.post('/goods/remark/getList', params) 
	},
    getRemarkCount (params) {
        return request.post('/goods/remark/getCount', params) 
    },
	getRemarkDetail (params) {
		return request.post('/goods/remark/getDetail', params) 
	},
	postRemarkAdd (params) {
		return request.post('/goods/remark/postAdd', params)
	},
	postRemarkModify (params) {
		return request.post('/goods/remark/postModify', params)
	},
	postRemarkDelete (params) {
		return request.post('/goods/remark/postDelete', params)
	},
    // 拆分
	getSplitList (params) {
		return request.post('/goods/split/getList', params) 
	},
	postSplitAdd (params) {
		return request.post('/goods/split/postAdd', params) 
	},
	postSplitDelete (params) {
		return request.post('/goods/split/postDelete', params)
	},
    // 库存预警的列表数据
    getWarningList (params) {
		return request.post('/goods/stock/warning', params)
    },
    // 库存预警的统计数据
    getWarningCount (params) {
		return request.post('/goods/stock/warningCount', params)
    },
    // 导出货单
    getExportList (params) {
		return request.post('/goods/stock/exportList', params)
    }
}



// WEBPACK FOOTER //
// ./src/api/goods.js